<template>

  <v-list two-line>
    <v-subheader>State</v-subheader>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Leg state
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ value.legState }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Boarding status
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ value.state }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Loadsheet
        </v-list-item-title>
        <v-list-item-subtitle>
          <template v-if="value.loadsheetStatus">
            {{ value.loadsheetStatus }}
          </template>
          <template v-else>
            -
          </template>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>

</template>

<script>

export default {
  name: 'FlightInfoState',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
  }),
  components: {
  },
  methods: {
  },
  computed: {
  }
}
</script>
